// src/pages/FindDealer.js

import React from 'react';
import { Helmet } from 'react-helmet-async';

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';
import Footer from '../../CommonComponent/Footer/footer';

// Page Component
import FindDealerForm from './PageComponent/FindDealerForm';

function FindDealer() {
  return (
    <>
      <Helmet>
        {/* Primary SEO Tags */}
        <title>Find A Dealer | Callistus Blinds</title>
        <meta
          name="description"
          content="Find a nearby Callistus Blinds showroom in your city. Share your details and our team will connect you with the closest dealer."
        />
        <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/find-dealer/`} />

        {/* Open Graph Tags (for Social Media) */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Find A Dealer" />
        <meta
          property="og:description"
          content="Find a nearby Callistus Blinds showroom in your city. Share your details and our team will connect you with the closest dealer."
        />
        <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/find-dealer/`} />
        <meta property="og:site_name" content="Callistus Blinds" />
      </Helmet>

      <div>
        <Navbar />
        <NotificationBar />
        <FindDealerForm />
        <Footer />
      </div>
    </>
  );
}

export default FindDealer;
